
export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_LUISS_API_ENDPOINT ? process.env.REACT_APP_LUISS_API_ENDPOINT : "https://ho4out7of9.execute-api.eu-west-1.amazonaws.com/prod",
    // BASE_URL: "https://d2nwa8fwbjskuj.cloudfront.net",
    PROD: "https://ho4out7of9.execute-api.eu-west-1.amazonaws.com/prod",
    PAGES_PREFIX: "",
    ITALIAN_MENU_ID: "main",
    ENGLISH_MENU_ID: "mainen",

    CORSI_E_MASTER_PATH: "/corsi-e-master",
    HOME_CONTENTS_PATH: "/home-contents2",
    HOME_CONTENTS_PATH2: "/home-contents",
    PAGES_MAPPING_PATH: "/uuid",
    PROFESSORS_PATH: "/professors",
    PROFESSORS_AREAS_PATH: "/professors_areas",
    PROFESSORS_KEYWORDS_PATH: "/professors_keywords",
    PROFESSORSHIPS_PATH: "/professorships",
    ACADEMIC_YEARS_PATH: "/academic_years",
    HOMEPAGE_BANNER: "/home-page-banners",
    CONTACT_FORM: "/webform"
};

export const LAST_COMPONENT_ID = "last-component";
